<template>
  <header
    class="header"
    :class="{ scrolled: isScrolled || isHovered }"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <div class="logo-container" @click="scrollTo('home')">
      <img
        src="@/assets/logo/logo_fixed.png"
        alt="太丰官网"
        class="logo-image"
      />
    </div>
    <nav class="nav-menu">
      <div
        class="nav-item"
        :class="{ active: activeNav === 'home' }"
        @click="scrollTo('home')"
      >
        首页
      </div>

      <div
        class="nav-item"
        :class="{ active: activeNav === 'about' }"
        @click="scrollTo('about')"
      >
        品牌简介
      </div>

      <div
        class="nav-item"
        :class="{
          active: $route.name === 'ProductDetail' || activeNav === 'products',
        }"
        @click="goToProductDetail"
      >
        产品
      </div>

      <div
        class="nav-item"
        :class="{ active: activeNav === 'company' }"
        @click="scrollTo('company')"
      >
        关于我们
      </div>

      <div
        class="nav-item"
        :class="{ active: activeNav === 'contact' }"
        @click="scrollTo('contact')"
      >
        联系我们
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: "Header",
  props: {
    activeNav: {
      type: String,
      default: "home",
    },
  },
  data() {
    return {
      isScrolled: false,
      isHovered: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    goToProductDetail() {
      if (
        this.$route.name === "ProductDetail" &&
        this.$route.params.id === "beef-jerky"
      ) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        this.$router.push({
          name: "ProductDetail",
          params: { id: "beef-jerky" },
        });
      }
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
    scrollTo(sectionId) {
      const isHomePage =
        this.$route.name === "Home" || this.$route.path === "/";

      if (!isHomePage) {
        this.$router.push({
          path: "/",
          query: { scrollTo: sectionId },
        });
      } else {
        this.$emit("nav-click", sectionId);
      }
    },
    scrollToBottom() {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 20px 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
  transition: all 0.3s ease;

  background-color: transparent;
  border-bottom: none;
}

.header.scrolled {
  background-color: rgba(255, 255, 255, 0.98);
  box-shadow: 0 5px 20px rgba(154, 27, 30, 0.1);
  padding: 15px 50px;
  border-bottom: 1px solid rgba(154, 27, 30, 0.15);
}

.header:hover {
  background-color: transparent;
}

.header.scrolled:hover {
  background-color: rgba(255, 255, 255, 0.98);
  box-shadow: 0 8px 25px rgba(154, 27, 30, 0.12);
}

.logo-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 50px;
  transition: all 0.3s ease;
}

.logo-image {
  height: 100%;
  width: auto;
  max-width: 150px;
  object-fit: contain;
  transition: all 0.3s ease;

  filter: brightness(0) invert(1) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.header.scrolled .logo-image {
  max-width: 130px;
  filter: brightness(1) invert(0) drop-shadow(0 2px 5px rgba(154, 27, 30, 0.1));
  opacity: 0.95;
}

.logo-container:hover {
  transform: translateY(-2px);
}

.logo-image:hover {
  transform: scale(1.05);
}

.header .logo-image:hover {
  filter: brightness(0) invert(1) drop-shadow(0 2px 8px rgba(0, 0, 0, 0.5));
}

.header.scrolled .logo-image:hover {
  filter: brightness(1) invert(0) drop-shadow(0 2px 8px rgba(154, 27, 30, 0.3));
}

.nav-menu {
  display: flex;
  gap: 40px;
  padding-right: 60px;
}

.nav-item {
  font-size: 1.1rem;
  font-weight: 600;
  color: white;
  text-shadow: 0 2px 5px rgba(0, 0, 0, 0.7);
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  padding: 8px 0;
  letter-spacing: 0.5px;
}

.header.scrolled .nav-item {
  color: #666;
  text-shadow: none;
}

.nav-item:hover,
.nav-item.active {
  color: white;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.9);
  transform: translateY(-1px);
}

.header.scrolled .nav-item:hover,
.header.scrolled .nav-item.active {
  color: #9a1b1e;
  text-shadow: none;
}

.nav-item::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 3px;
  background: linear-gradient(90deg, white, rgba(255, 255, 255, 0.8));
  transition: width 0.3s;
  border-radius: 1.5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}

.header.scrolled .nav-item::after {
  background: linear-gradient(90deg, #9a1b1e, #b22222);
  box-shadow: 0 2px 5px rgba(154, 27, 30, 0.3);
}

.nav-item:hover::after,
.nav-item.active::after {
  width: 100%;
}

.nav-item.active {
  font-weight: 700;
}

.nav-item.active::before {
  display: none;
}

@media (max-width: 768px) {
  .header {
    padding: 15px 20px;
    background-color: transparent;
  }

  .header.scrolled {
    padding: 10px 20px;
    background-color: rgba(255, 255, 255, 0.98);
    box-shadow: 0 3px 15px rgba(154, 27, 30, 0.1);
  }

  .logo-container {
    height: 40px;
  }

  .logo-image {
    max-width: 120px;
  }

  .header.scrolled .logo-image {
    max-width: 100px;
  }

  .nav-menu {
    gap: 20px;
    padding-right: 20px;
  }

  .nav-item {
    font-size: 1rem;
    padding: 6px 0;
  }
}

@media (max-width: 576px) {
  .logo-image {
    max-width: 100px;
  }

  .header.scrolled .logo-image {
    max-width: 90px;
  }

  .nav-menu {
    gap: 15px;
    padding-right: 10px;
  }
}

@media (max-width: 480px) {
  .logo-container {
    height: 35px;
  }

  .logo-image {
    max-width: 90px;
  }

  .nav-menu {
    gap: 10px;
  }

  .nav-item {
    font-size: 0.9rem;
    padding: 5px 0;
  }
}

.header::after {
  display: none;
}

.header.scrolled::after {
  display: none;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.header {
  animation: fadeInDown 0.5s ease-out;
}

.nav-item:nth-child(1) {
  animation-delay: 0.1s;
}
.nav-item:nth-child(2) {
  animation-delay: 0.2s;
}
.nav-item:nth-child(3) {
  animation-delay: 0.3s;
}
.nav-item:nth-child(4) {
  animation-delay: 0.4s;
}

.header {
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
</style>
